/* unplugin-vue-components disabled */import { render } from "./scroll-bar.vue?vue&type=template&id=d70bec7a&scoped=true"
import script from "./scroll-bar.vue?vue&type=script&lang=js"
export * from "./scroll-bar.vue?vue&type=script&lang=js"

import "./scroll-bar.vue?vue&type=style&index=0&id=d70bec7a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70bec7a"],['__file',"src/controls/scroll-bar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d70bec7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d70bec7a', __exports__)) {
    api.reload('d70bec7a', __exports__)
  }
  
  module.hot.accept("./scroll-bar.vue?vue&type=template&id=d70bec7a&scoped=true", () => {
    api.rerender('d70bec7a', render)
  })

}


export default __exports__